import React from "react";
import { NMPopup } from "@neumetric/blueprint-lib/components";
import { riskActions, getImportRisksCount } from "../../store";
import { useDispatch, useSelector } from "react-redux";

export const ImportRisks = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const importRisksCount = useSelector(getImportRisksCount);
  React.useEffect(() => {
    if (open) {
      dispatch(riskActions.fetchImportRisksCount());
    }
  }, [open]);
  const countText = importRisksCount ?? "0";

  return (
    <NMPopup
      visible={open}
      title="Import Risks?"
      variant="INFO"
      onModalClose={onClose}
      actions={[
        {
          label: "Cancel",
          icon: "CANCEL",
          btnType: "TEXT",
          onClick: () => onClose(),
        },
        {
          label: "Confirm",
          icon: "CHECK_CONFIRM",
          btnType: "CONTAINED",
          variant: "ACTION",
          onClick: () => {
            dispatch(riskActions.importRisksFromBlueprint());
            onClose();
          },
        },
      ]}
    >
      <div className="ff-exo2 fs-15 line-24">
        This action will create <b>{countText} risks</b> (from blueprints).
        <br />
        Risks will be pre-populated with available values mentioned
        <br />
        below
        <br />
        • Title, Context & Consequences
        <br />
        • Stakeholder, Source, Asset, Threat & Vulnerability
        <br />
        • Department & Responder
        <br />
        • Ratings (Confidentiality, Integrity, Availability, Probability &
        Impact )
        <br />
        • Score, Decision & Severity
        <br />
        • Controls & References
        <br />
        <br />
        <b>IMPORTANT!</b>
        <br />
        Risk Register DOES NOT show Acceptable Risks (they are filitered out).
        <br />
        Modify the filters to view them.
      </div>
    </NMPopup>
  );
};
